/**
 * VoicePickerSheet — окно выбора голоса озвучки (десктоп-пилюля «Голос» в
 * виджете). Голосов в библиотеке сотни, фильтры по языку и сценарию — в
 * выпадашку пилюли это не влезает, поэтому своё окно, как у «Диалога».
 */
import Sheet from '../../../components/Sheet'
import VoiceLibraryPanel from './VoiceLibraryPanel'
import type { TtsVoice } from '../utils/ttsVoices'

interface Props {
	open: boolean
	onClose: () => void
	currentVoiceId?: string | null
	onSelect: (voice: TtsVoice) => void
}

export default function VoicePickerSheet({ open, onClose, currentVoiceId, onSelect }: Props) {
	return (
		<Sheet open={open} onClose={onClose} variant="center" title="Голос" className="voice-picker-sheet">
			{open && (
				<VoiceLibraryPanel
					currentVoiceId={currentVoiceId}
					onSelect={(v) => {
						onSelect(v)
						onClose()
					}}
				/>
			)}
		</Sheet>
	)
}
